import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  banner: {
    borderRadius: rw(20),
    overflow: 'hidden',
  },
  bannerContent: {
    padding: rw(24),
  },
  background: { position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 },
  copy: { paddingRight: rw(100), minWidth: 0 },
  textDark: { color: theme.COLOR_NEUTRAL_500 },
  title: {
    color: theme.COLOR_TEXT_INVERSE_PRIMARY,
    fontSize: rf(18),
    lineHeight: rh(22),
  },
  text: {
    color: theme.COLOR_TEXT_INVERSE_SECONDARY,
    fontSize: rf(14),
    lineHeight: rh(21),
  },
  action: {
    color: theme.COLOR_TEXT_INVERSE_PRIMARY,
    fontSize: rf(16),
    lineHeight: rh(20),
  },
  artWrap: {
    alignItems: 'center',
    height: rh(109.4),
    justifyContent: 'center',
    position: 'absolute',
    right: rw(0),
    top: rh(3.3),
    width: rw(109.4),
  },
  art: {
    height: rw(92),
    overflow: 'hidden',
    transform: [{ rotate: '12.23deg' }],
    width: rw(92),
  },
  artImage: {
    height: '100%',
    width: '100%',
  },
}))
